import initMrNotes from './init_mr_notes';

export default initMrNotes;
